module.exports = "/images/person-icon.svg?c24b9437178e058c808494729a86aa4b";